// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"93e0cbf6","453":"d855a71b","551":"eebf1ec6","950":"fc47bf65"}[chunkId] + ".chunk.js";
};